export { XPath, ExprContext } from './xpath';
export { Xslt, XsltOptions } from './xslt';
export { XmlParser, xmlEscapeText, xmlTransformedText, XDocument, XNode, domDocumentToXDocument } from './dom';
